














































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { CommonFormService } from "../../service/common-form.service";
import { CommonForm, CommonFormFeedbackFollowup } from "../../models/common-form";
import { ContentService } from "@/service/content.service";
import { FeedbackFollowupContent } from "@/models/content/feedback-followup";
import CommonMixin from "@/mixins/common-mixins";
import moment from 'moment'
import { FeedbackForm } from "@/models/feedback-form";
import { ProviderNotificationData } from "@/models/notification-data";

@Component({
  components: {},
})
export default class FeedbackFollowup extends Mixins(CommonMixin) {
  commonFormService = new CommonFormService();
  contentService = new ContentService();
  content: FeedbackFollowupContent = {} as FeedbackFollowupContent;
  pageData = {} as CommonFormFeedbackFollowup;
  commonForm = {} as CommonForm;
  feedbackForm = {} as FeedbackForm;
  notificationData: Array<ProviderNotificationData> = [];
  pageDataLoaded = false;
  haveBadToken = false;

  async mounted(): Promise<void> {
    try {
      this.content = await this.contentService.getFeedbackFollowupContent();
      const token = this.$route.params.token;
      this.pageData = await this.commonFormService.getFeedbackFollowup(token);
      if ( this.pageData.commonForm) {
        this.commonForm = this.pageData.commonForm
      }

      if ( this.pageData.feedbackForm) {
        this.feedbackForm = this.pageData.feedbackForm
      }

      if ( this.pageData.notificationData) {
        this.notificationData = this.pageData.notificationData
      }
      this.pageDataLoaded = true;
    } catch (error) {
      if (error.response.status === 422) {
        this.haveBadToken = true;
      }
    }
  }


  get languages(): string {
    const languages = [];
    if (this.commonForm.caregiver.speakenglish === true) {
      languages.push("English");
    }
    if (this.commonForm.caregiver.speakspanish === true) {
      languages.push("Spanish");
    }
    if (this.commonForm.caregiver.speakarabic === true) {
      languages.push("Arabic");
    }
    if (this.commonForm.caregiver.speakother === true) {
      languages.push(this.commonForm.caregiver.otherlanguage);
    }
    return languages.join(", ");
  }

  get formCompletedLanguage(): string {
    if (this.commonForm.language === "es") {
      return "Spanish";
    } else if (this.commonForm.language === "ar") {
      return "Arabic";
    } else {
      return "English";
    }
  }

   get formSubmittedDate(): string {
    if ( this.commonForm.modifieddate != null) {
        return  moment(this.commonForm.modifieddate).format('MM/DD/YYYY');
    }
    return ''
  }
}


